
import { Component, Mixins } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import vselect3 from "vselect3";
import { debounce } from "lodash";

import AlarmActionsMixin from "@/mixins/AlarmActionsMixin";
import { Response } from "@/store/responses/types";
import api from "@/services/api.service";
import { extractPropertyFromXml } from "@/utils/string-utils";

const Responses = namespace("responses");

const debouncePeriod: number = process.env.NODE_ENV === "test" ? 1 : 500;

@Component({
	components: {
		"v-select-3": vselect3
	},
	validations: {
		currentAlarmAction: { objectID: { required } },
		hasDataChanged: {
			required: requiredIf(function() {
				return (
					this.currentAlarmAction.settingsMeta.toString() === this.originalArmStatus &&
					this.currentAlarmAction.objectID === this.originalObjectId
				);
			})
		}
	}
})
export default class ActionSetupArmAlarm extends Mixins(AlarmActionsMixin, validationMixin) {
	@Responses.State("responses") private responsesFromStore: Response[];

	private originalArmStatus: string = null;
	private originalObjectId: number = null;
	private responses: Response[] = [];
	private selectedAlarm: Response = null;

	public async created(): Promise<void> {
		this.responses = [...this.responsesFromStore];

		if (this.isEditing) {
			const { data } = await api.fetchResponse(this.currentAlarmAction.objectID);
			this.selectedAlarm = data;

			this.currentAlarmAction.settingsMeta = extractPropertyFromXml(
				this.currentAlarmAction.settingsMeta,
				"newstate"
			);

			this.originalArmStatus = this.currentAlarmAction.settingsMeta;
			this.originalObjectId = this.currentAlarmAction.objectID;
		}
	}

	private handleAlarmSelected(): void {
		this.currentAlarmAction.objectID = this.selectedAlarm && this.selectedAlarm.responseID;
	}

	private handleAlarmSearch(searchTerm: string, loading: (boolean) => void): void {
		loading(true);
		this.debounceSearch(searchTerm, loading);
	}

	private debounceSearch = debounce(async (searchTerm: string, loading: (boolean) => void): Promise<void> => {
		await this.searchAlarms(searchTerm, loading);
	}, debouncePeriod);

	private async searchAlarms(searchTerm: string, loading: (boolean) => void): Promise<void> {
		const { data }: { data: Response[] } = await api.fetchResponses(1, 200, searchTerm, 0);
		this.responses = data;

		loading(false);
	}
}
